import EditProfile from 'profile/components/edit';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { reduxForm } from 'redux-form';
import { saveProfile } from 'profile/ducks/shared';
import { fetchSpecializations } from 'profile/ducks/specializations';

import { PROFILE_FORM, PRIMARY_LANG_REQUIRED_MSG, NEED_SPECIALIZATION_MSG } from 'profile/constants';

export function validate(values) {
  const errors = {};

  if (!values.primary_lang) {
    errors.primary_lang = PRIMARY_LANG_REQUIRED_MSG;
  }

  const hasSpecializations = values.specializations ?
    values.specializations.reduce((mem, specialization) => (
      specialization && specialization.trim() ? mem + 1 : mem
    ), 0) : false;

  if (!hasSpecializations) {
    errors.specializations = { _error: NEED_SPECIALIZATION_MSG };
  }

  return errors;
}

export const getAboutHiddenReason = (view) => {
  const profile = view.data || { publishedProjects: [] };
  if (profile.is_client && profile.publishedProjects.length == 0) {
    return "This info won't be publicly visible until you post your first project.";
  }
  if (profile.is_creative && !profile.allowed_to_participate) {
    return "This info won't be publicly visible until you have been approved to participate in projects.";
  }
}

export function mapStateToProps({ user, profile: { view, specializations } }, { params }) {
  const initialSpecializations = view.data.specializations.map(({ id }) => (id));

  const initialValues = {
    ...view.data,
    specializations: initialSpecializations,
  };

  return {
    isEditingOwn: user.logged_in && user.profile_data.username === params.profileUsername,
    isLoading: view.isLoading || specializations.isLoading || !specializations.data.length,
    aboutHiddenReason: getAboutHiddenReason(view),
    initialValues,
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  return bindActionCreators({
    goToProfile: partial(push, `/users/${params.profileUsername}`),
    onSubmit: saveProfile,
    fetchSpecializations,
  }, dispatch);
}

const EditProfileForm = reduxForm({
  form: PROFILE_FORM,
  validate,
})(EditProfile);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProfileForm));



// WEBPACK FOOTER //
// ./profile/containers/edit.js